import { CompSearchRejectionReason } from '../comp-search-rejection-reason';

export class EvaluateComparableModalPayload {
  sourceIds: string[];
  pbaId: number;
  studyId: number;
  compSearchId: number;
  jurisdictionId: number;
  pliTypeId: number;
  pliAvgTypeId: number;
  currentCompInListIndex: number;
  rejectionReasons: CompSearchRejectionReason[];
  containerId: number;
}
